

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const NEWSLETTEREDITBYID= createAsyncThunk(
  "NewsLetterEditById/NewsLetterEditById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const NewsLetterEditByIdSlice = createSlice({
  name: "NewsLetterEditByIdSlice",
  initialState: {
    NewsLetterEditById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfNewsLetterEditById: (state) => {
        state.NewsLetterEditById.loading = false
        state.NewsLetterEditById.error = false
        state.NewsLetterEditById.data = []
        state.NewsLetterEditById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(NEWSLETTEREDITBYID.fulfilled, (state, action) => {
      state.NewsLetterEditById = {
        ...state.NewsLetterEditById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTEREDITBYID.pending, (state, action) => {
      state.NewsLetterEditById = {
        ...state.NewsLetterEditById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTEREDITBYID.rejected, (state, action) => {
      state.NewsLetterEditById = {
        ...state.NewsLetterEditById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const NewsLetterEditByIdAction = {
    NEWSLETTEREDITBYID,
};

export { NewsLetterEditByIdAction };
export default NewsLetterEditByIdSlice.reducer;
export const {setInitialStateOfNewsLetterEditById} = NewsLetterEditByIdSlice.actions
